/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as appV1 from "./keyapis_multiapp_app_v1.pb"

/**
 * Сервис реализует функционал управления шаблонами уведомлений
 */

/**
 * Сервис шаблонов уведомлений
 */
export class NotificationTemplateServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод сохранения шаблона уведомления.
   * Поддерживает создание и обновление.
   * Поддерживает mustache теги в переменных template_header и template_text.
   * Сценарий использования метода: https://confluence.rt.ru/pages/viewpage.action?pageId=774989444.
   * Метод доступен для: admin, manager, service
   */
  PostNotificationTemplate = (req: PostNotificationTemplateRequestDto, init?: RequestInit): Promise<PostNotificationTemplateResponseDto> => {
    return fm.request<PostNotificationTemplateRequestDto, PostNotificationTemplateResponseDto>(`${this.host}/multiapp/api/v1/notification_template`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения шаблона уведомления.
   * Метод доступен для: admin, manager, service, partner.
   * Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.
   * Роли partner доступны только связанные с ней шаблоны
   */
  GetNotificationTemplate = (req: GetNotificationTemplateRequestDto, init?: RequestInit): Promise<GetNotificationTemplateResponseDto> => {
    return fm.request<GetNotificationTemplateRequestDto, GetNotificationTemplateResponseDto>(`${this.host}/multiapp/api/v1/notification_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления шаблона уведомления.
   * Устанавливает текущую дату и время в параметр deleted_at.
   * Метод доступен для: admin, manager, service
   */
  DeleteNotificationTemplate = (req: DeleteNotificationTemplateRequestDto, init?: RequestInit): Promise<DeleteNotificationTemplateResponseDto> => {
    return fm.request<DeleteNotificationTemplateRequestDto, DeleteNotificationTemplateResponseDto>(`${this.host}/multiapp/api/v1/notification_template/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка шаблонов уведомлений.
   * Метод доступен для: admin, manager, service, partner.
   * Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.
   * Если метод вызван ролью partner в фильтре поле partner_ids принудительно замещается его идентификатором
   */
  GetNotificationTemplateList = (req?: GetNotificationTemplateListRequestDto, init?: RequestInit): Promise<GetNotificationTemplateListResponseDto[]> => {
    return fm.list<GetNotificationTemplateListRequestDto, GetNotificationTemplateListResponseDto>(`${this.host}/multiapp/api/v1/notification_template/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества шаблонов уведомлений.
   * Метод доступен для: admin, manager, service, partner.
   * Роль partner определяется по наличию заголовка X-API-KEY вместо Authorization.
   * Если метод вызван ролью partner в фильтре поле partner_ids принудительно замещается его идентификатором
   */
  GetNotificationTemplateCount = (req?: GetNotificationTemplateCountRequestDto, init?: RequestInit): Promise<GetNotificationTemplateCountResponseDto> => {
    return fm.request<GetNotificationTemplateCountRequestDto, GetNotificationTemplateCountResponseDto>(`${this.host}/multiapp/api/v1/notification_template/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод создания связи шаблона уведомления и партнера.
   * Метод доступен для: admin, manager, service
   */
  PutNotificationTemplatePartnerAttach = (req: PutNotificationTemplatePartnerAttachRequestDto, init?: RequestInit): Promise<PutNotificationTemplatePartnerAttachResponseDto> => {
    return fm.request<PutNotificationTemplatePartnerAttachRequestDto, PutNotificationTemplatePartnerAttachResponseDto>(`${this.host}/multiapp/api/v1/notification_template/${encodeURIComponent(req.notificationTemplatePartner.notificationTemplateId)}/partner/${encodeURIComponent(req.notificationTemplatePartner.partnerId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связи шаблона уведомления и партнера.
   * Метод доступен для: admin, manager, service
   */
  PutNotificationTemplatePartnerDetach = (req: PutNotificationTemplatePartnerDetachRequestDto, init?: RequestInit): Promise<PutNotificationTemplatePartnerDetachResponseDto> => {
    return fm.request<PutNotificationTemplatePartnerDetachRequestDto, PutNotificationTemplatePartnerDetachResponseDto>(`${this.host}/multiapp/api/v1/notification_template/${encodeURIComponent(req.notificationTemplatePartner.notificationTemplateId)}/partner/${encodeURIComponent(req.notificationTemplatePartner.partnerId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки.
 */
export enum NotificationTemplatePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type NotificationTemplatePagingDirectionTypeResponseEnum = keyof typeof NotificationTemplatePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type NotificationTemplatePagingDirectionTypeRequestEnum = Exclude<NotificationTemplatePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum NotificationTemplatePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * Дата последнего изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * Дата создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type NotificationTemplatePagingOrderByTypeResponseEnum = keyof typeof NotificationTemplatePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type NotificationTemplatePagingOrderByTypeRequestEnum = Exclude<NotificationTemplatePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос на удаление шаблона уведомления
 */
export type DeleteNotificationTemplateRequestDto = {
  /**
   * Идентификатор шаблона уведомления.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос удаления шаблона уведомления
 */
export type DeleteNotificationTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка при удалении
   */
  readonly error: DeleteNotificationTemplateResponseErrorDto
}>
/**
 * Ошибка удаления шаблона уведомления
 */
export type DeleteNotificationTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка удаления шаблона уведомления
 */
export type DeleteNotificationTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества шаблонов уведомлений
 */
export type GetNotificationTemplateCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: NotificationTemplateFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества шаблонов уведомлений
 */
export type GetNotificationTemplateCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего шаблонов уведомлений
   */
  readonly data: number
  /**
   * Ошибка
   */
  readonly error: GetNotificationTemplateCountResponseErrorDto
}>
/**
 * Ошибка запроса получения количества шаблонов уведомлений
 */
export type GetNotificationTemplateCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения количества шаблонов уведомлений
 */
export type GetNotificationTemplateCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка шаблонов уведомлений
 */
export type GetNotificationTemplateListRequestDto = {
  /**
   * Фильтр
   */
  filter?: NotificationTemplateFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: NotificationTemplatePagingRequestDto
}>
/**
 * Ответ на запрос получения списка шаблонов уведомлений
 */
export type GetNotificationTemplateListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон уведомления
   */
  readonly data: NotificationTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetNotificationTemplateListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка шаблонов уведомлений
 */
export type GetNotificationTemplateListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка шаблонов уведомлений
 */
export type GetNotificationTemplateListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения шаблона уведомления
 */
export type GetNotificationTemplateRequestDto = {
  /**
   * Идентификатор шаблона уведомления.
   * # Тип: Guid
   */
  id: string
}
/**
 * Ответ на запрос получения шаблона уведомления
 */
export type GetNotificationTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон уведомления
   */
  readonly data: NotificationTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: GetNotificationTemplateResponseErrorDto
}>
/**
 * Ошибка запроса получения шаблона уведомления
 */
export type GetNotificationTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения шаблона уведомления
 */
export type GetNotificationTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Шаблон уведомления.
 * # Описание модели
 */
export type NotificationTemplateRequestDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id?: string
  /**
   * Заголовок шаблона.
   * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
   * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
   * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
   * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
   * # Диапазон: 3..128
   */
  templateHeader: string
  /**
   * Тело шаблона.
   * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
   * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
   * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
   * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
   * # Диапазон: 3..512
   */
  templateText: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * При изменении должен совпадать со значением из БД.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt?: string | null
  /**
   * Системное наименование.
   * # Диапазон: 3..256
   */
  title: string
}
/**
 * Шаблон уведомления.
 * # Описание модели
 */
export type NotificationTemplateResponseDto = {
  /**
   * Идентификатор.
   * Если не передан создаётся сервером.
   * # Тип: Guid
   */
  id: string
  /**
   * Заголовок шаблона.
   * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
   * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
   * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
   * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
   * # Диапазон: 3..128
   */
  templateHeader: string
  /**
   * Тело шаблона.
   * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
   * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
   * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
   * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
   * # Диапазон: 3..512
   */
  templateText: string
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * При изменении должен совпадать со значением из БД.
   * Является версией объекта.
   * # Тип: DateTime
   */
  changedAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime?
   */
  readonly deletedAt: string | null
  /**
   * Системное наименование.
   * # Диапазон: 3..256
   */
  title: string
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type NotificationTemplateSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: NotificationTemplateSavingErrorConflictRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type NotificationTemplateSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Конфликт версий
   */
  readonly conflict: NotificationTemplateSavingErrorConflictResponseDto
}>
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type NotificationTemplateSavingErrorConflictRequestDto = {
}
/**
 * Конфликт версий.
 * Причины:
 * - В базе хранится другая версия строки, значения changed_at отличаются
 */
export type NotificationTemplateSavingErrorConflictResponseDto = {
}
/**
 * Фильтр шаблонов уведомлений
 */
export type NotificationTemplateFilterRequestDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Заголовок шаблона;
   * # - Тело шаблона;
   * # - Системное наименование
   */
  text?: string | null
  /**
   * По идентификаторам партнера.
   * # Тип: Guid
   */
  partnerIds?: string[]
  /**
   * Показывать удаленные
   */
  isShowDeleted?: boolean | null
}
/**
 * Фильтр шаблонов уведомлений
 */
export type NotificationTemplateFilterResponseDto = {
  /**
   * По тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Заголовок шаблона;
   * # - Тело шаблона;
   * # - Системное наименование
   */
  text: string | null
  /**
   * По идентификаторам партнера.
   * # Тип: Guid
   */
  partnerIds: string[]
  /**
   * Показывать удаленные
   */
  isShowDeleted: boolean | null
}
/**
 * Пагинация шаблонов уведомлений
 */
export type NotificationTemplatePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: NotificationTemplatePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: NotificationTemplatePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Пагинация шаблонов уведомлений
 */
export type NotificationTemplatePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: NotificationTemplatePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: NotificationTemplatePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Связь шаблона уведомлений и партнера.
 * # Описание модели
 */
export type NotificationTemplatePartnerRequestDto = {
  /**
   * Идентификатор шаблона уведомления.
   * # Тип: Guid
   */
  notificationTemplateId: string
  /**
   * Идентификатор партнера.
   * # Тип: Guid
   */
  partnerId: string
}
/**
 * Связь шаблона уведомлений и партнера.
 * # Описание модели
 */
export type NotificationTemplatePartnerResponseDto = {
  /**
   * Идентификатор шаблона уведомления.
   * # Тип: Guid
   */
  notificationTemplateId: string
  /**
   * Идентификатор партнера.
   * # Тип: Guid
   */
  partnerId: string
}
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type NotificationTemplatePartnerSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Партнер удален
   */
  readonly partnerIsDeleted: NotificationTemplatePartnerSavingErrorPartnerIsDeletedRequestDto
  /**
   * Шаблон удален
   */
  readonly templateIsDeleted: NotificationTemplatePartnerSavingErrorTemplateIsDeletedRequestDto
}>
/**
 * Ошибка сохранения.
 * Эти проверки выполняются при работе с базой данных и сторонними сервисами
 */
export type NotificationTemplatePartnerSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Партнер удален
   */
  readonly partnerIsDeleted: NotificationTemplatePartnerSavingErrorPartnerIsDeletedResponseDto
  /**
   * Шаблон удален
   */
  readonly templateIsDeleted: NotificationTemplatePartnerSavingErrorTemplateIsDeletedResponseDto
}>
/**
 * Партнер удален
 */
export type NotificationTemplatePartnerSavingErrorPartnerIsDeletedRequestDto = {
}
/**
 * Партнер удален
 */
export type NotificationTemplatePartnerSavingErrorPartnerIsDeletedResponseDto = {
}
/**
 * Шаблон удален
 */
export type NotificationTemplatePartnerSavingErrorTemplateIsDeletedRequestDto = {
}
/**
 * Шаблон удален
 */
export type NotificationTemplatePartnerSavingErrorTemplateIsDeletedResponseDto = {
}
/**
 * Запрос сохранения приложения
 */
export type PostNotificationTemplateRequestDto = {
  /**
   * Приложение
   */
  data: NotificationTemplateRequestDto
}
/**
 * Ответ на запрос сохранения шаблона уведомления
 */
export type PostNotificationTemplateResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Шаблон уведомления
   */
  readonly data: NotificationTemplateResponseDto
  /**
   * Ошибка
   */
  readonly error: PostNotificationTemplateResponseErrorDto
}>
/**
 * Ошибка запроса сохранения шаблона уведомления
 */
export type PostNotificationTemplateResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: NotificationTemplateSavingErrorRequestDto
  /**
   * Некорректный тип данных для переменной в шаблоне
   */
  readonly incorrectDataType: PostNotificationTemplateResponseErrorIncorrectDataTypeErrorRequestDto
  /**
   * Некорректное наименование переменной в шаблоне
   */
  readonly incorrectVariableNameError: PostNotificationTemplateResponseErrorIncorrectVariableNameErrorRequestDto
  /**
   * Некорректный формат Mustache тегов
   */
  readonly incorrectTagFormatError: PostNotificationTemplateResponseErrorIncorrectTagFormatErrorRequestDto
}>
/**
 * Ошибка запроса сохранения шаблона уведомления
 */
export type PostNotificationTemplateResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: NotificationTemplateSavingErrorResponseDto
  /**
   * Некорректный тип данных для переменной в шаблоне
   */
  readonly incorrectDataType: PostNotificationTemplateResponseErrorIncorrectDataTypeErrorDto
  /**
   * Некорректное наименование переменной в шаблоне
   */
  readonly incorrectVariableNameError: PostNotificationTemplateResponseErrorIncorrectVariableNameErrorDto
  /**
   * Некорректный формат Mustache тегов
   */
  readonly incorrectTagFormatError: PostNotificationTemplateResponseErrorIncorrectTagFormatErrorDto
}>
/**
 * Некорректный тип данных для переменной в шаблоне.
 * Список допустимых типов данных:
 * - Number;
 * - Date;
 * - Phone;
 * - Time
 */
export type PostNotificationTemplateResponseErrorIncorrectDataTypeErrorRequestDto = {
}
/**
 * Некорректный тип данных для переменной в шаблоне.
 * Список допустимых типов данных:
 * - Number;
 * - Date;
 * - Phone;
 * - Time
 */
export type PostNotificationTemplateResponseErrorIncorrectDataTypeErrorDto = {
}
/**
 * Некорректный формат Mustache тегов
 */
export type PostNotificationTemplateResponseErrorIncorrectTagFormatErrorRequestDto = {
}
/**
 * Некорректный формат Mustache тегов
 */
export type PostNotificationTemplateResponseErrorIncorrectTagFormatErrorDto = {
}
/**
 * Некорректное наименование переменной в шаблоне
 */
export type PostNotificationTemplateResponseErrorIncorrectVariableNameErrorRequestDto = {
}
/**
 * Некорректное наименование переменной в шаблоне
 */
export type PostNotificationTemplateResponseErrorIncorrectVariableNameErrorDto = {
}
/**
 * Запрос создания связи шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerAttachRequestDto = {
  /**
   * Связь шаблона уведомления и партнера
   */
  notificationTemplatePartner: NotificationTemplatePartnerRequestDto
}
/**
 * Ответ на запрос создания связи шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutNotificationTemplatePartnerAttachResponseErrorDto
}>
/**
 * Ошибка запроса на создание шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: NotificationTemplatePartnerSavingErrorRequestDto
}>
/**
 * Ошибка запроса на создание шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: NotificationTemplatePartnerSavingErrorResponseDto
}>
/**
 * Запрос удаления связи шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerDetachRequestDto = {
  /**
   * Связь шаблона уведомления и партнера
   */
  notificationTemplatePartner: NotificationTemplatePartnerRequestDto
}
/**
 * Ответ на запрос удаление связи шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutNotificationTemplatePartnerDetachResponseErrorDto
}>
/**
 * Ошибка запроса на удаление шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на удаление шаблона уведомления и партнера
 */
export type PutNotificationTemplatePartnerDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: appV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на удаление шаблона уведомления
   */
  "DeleteNotificationTemplateRequest": {
    "kind": "class",
    "text": "Запрос на удаление шаблона уведомления",
    "fields": {
      /**
       * Идентификатор шаблона уведомления.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона уведомления.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления шаблона уведомления
   */
  "DeleteNotificationTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления шаблона уведомления",
    "fields": {
      /**
       * Ошибка при удалении
       */
      "error": {
        "type": "DeleteNotificationTemplateResponse.Error",
        "text": "Ошибка при удалении",
      },
    },
  },
  /**
   * Ошибка удаления шаблона уведомления
   */
  "DeleteNotificationTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления шаблона уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества шаблонов уведомлений
   */
  "GetNotificationTemplateCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества шаблонов уведомлений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "NotificationTemplateFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества шаблонов уведомлений
   */
  "GetNotificationTemplateCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества шаблонов уведомлений",
    "fields": {
      /**
       * Всего шаблонов уведомлений
       */
      "data": {
        "type": "int32",
        "text": "Всего шаблонов уведомлений",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationTemplateCountResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения количества шаблонов уведомлений
   */
  "GetNotificationTemplateCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения количества шаблонов уведомлений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка шаблонов уведомлений
   */
  "GetNotificationTemplateListRequest": {
    "kind": "class",
    "text": "Запрос получения списка шаблонов уведомлений",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "NotificationTemplateFilter",
        "text": "Фильтр",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "NotificationTemplatePaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка шаблонов уведомлений
   */
  "GetNotificationTemplateListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка шаблонов уведомлений",
    "fields": {
      /**
       * Шаблон уведомления
       */
      "data": {
        "type": "NotificationTemplate",
        "text": "Шаблон уведомления",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationTemplateListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка шаблонов уведомлений
   */
  "GetNotificationTemplateListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка шаблонов уведомлений",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения шаблона уведомления
   */
  "GetNotificationTemplateRequest": {
    "kind": "class",
    "text": "Запрос получения шаблона уведомления",
    "fields": {
      /**
       * Идентификатор шаблона уведомления.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор шаблона уведомления.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения шаблона уведомления
   */
  "GetNotificationTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения шаблона уведомления",
    "fields": {
      /**
       * Шаблон уведомления
       */
      "data": {
        "type": "NotificationTemplate",
        "text": "Шаблон уведомления",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetNotificationTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения шаблона уведомления
   */
  "GetNotificationTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения шаблона уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Шаблон уведомления.
   * # Описание модели
   */
  "NotificationTemplate": {
    "kind": "class",
    "text": "Шаблон уведомления.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор.
       * Если не передан создаётся сервером.
       * # Тип: Guid
       */
      "id": {
        "type": "string",
        "text": "Идентификатор.\nЕсли не передан создаётся сервером.\n# Тип: Guid",
      },
      /**
       * Заголовок шаблона.
       * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
       * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
       * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
       * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
       * # Диапазон: 3..128
       */
      "templateHeader": {
        "type": "string",
        "text": "Заголовок шаблона.\nПоддерживает mustache теги в формате: {{название переменной|тип данных}}.\nНазвание переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".\nТип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.\nСимволы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.\n# Диапазон: 3..128",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 128,
            "message": "Значение не входит в допустимый диапазон. Максимум: 128"
          },
        }
      },
      /**
       * Тело шаблона.
       * Поддерживает mustache теги в формате: {{название переменной|тип данных}}.
       * Название переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".
       * Тип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.
       * Символы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.
       * # Диапазон: 3..512
       */
      "templateText": {
        "type": "string",
        "text": "Тело шаблона.\nПоддерживает mustache теги в формате: {{название переменной|тип данных}}.\nНазвание переменной в теге может содержать латинские буквы (в верхнем или нижнем регистре), цифры и символ \"_\".\nТип данных может быть указан в верхнем или нижнем регистре, пробелы не допускаются, допустимые типы данных указаны в таблице.\nСимволы \"{\" и \"}\" являются служебными и могут использоваться только для формирования Mustache тегов.\n# Диапазон: 3..512",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 512,
            "message": "Значение не входит в допустимый диапазон. Максимум: 512"
          },
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * При изменении должен совпадать со значением из БД.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nПри изменении должен совпадать со значением из БД.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime?
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime?",
      },
      /**
       * Системное наименование.
       * # Диапазон: 3..256
       */
      "title": {
        "type": "string",
        "text": "Системное наименование.\n# Диапазон: 3..256",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 256,
            "message": "Значение не входит в допустимый диапазон. Максимум: 256"
          },
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "NotificationTemplate.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Конфликт версий
       */
      "conflict": {
        "type": "NotificationTemplate.SavingError.Conflict",
        "text": "Конфликт версий",
      },
    },
  },
  /**
   * Конфликт версий.
   * Причины:
   * - В базе хранится другая версия строки, значения changed_at отличаются
   */
  "NotificationTemplate.SavingError.Conflict": {
    "kind": "class",
    "text": "Конфликт версий.\nПричины:\n- В базе хранится другая версия строки, значения changed_at отличаются",
  },
  /**
   * Фильтр шаблонов уведомлений
   */
  "NotificationTemplateFilter": {
    "kind": "class",
    "text": "Фильтр шаблонов уведомлений",
    "fields": {
      /**
       * По тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Заголовок шаблона;
       * # - Тело шаблона;
       * # - Системное наименование
       */
      "text": {
        "type": "google.protobuf.StringValue",
        "text": "По тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Заголовок шаблона;\n# - Тело шаблона;\n# - Системное наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По идентификаторам партнера.
       * # Тип: Guid
       */
      "partnerIds": {
        "type": "string",
        "text": "По идентификаторам партнера.\n# Тип: Guid",
      },
      /**
       * Показывать удаленные
       */
      "isShowDeleted": {
        "type": "google.protobuf.BoolValue",
        "text": "Показывать удаленные",
      },
    },
  },
  /**
   * Пагинация шаблонов уведомлений
   */
  "NotificationTemplatePaging": {
    "kind": "class",
    "text": "Пагинация шаблонов уведомлений",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "NotificationTemplatePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "NotificationTemplatePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Связь шаблона уведомлений и партнера.
   * # Описание модели
   */
  "NotificationTemplatePartner": {
    "kind": "class",
    "text": "Связь шаблона уведомлений и партнера.\n# Описание модели",
    "fields": {
      /**
       * Идентификатор шаблона уведомления.
       * # Тип: Guid
       */
      "notificationTemplateId": {
        "type": "string",
        "text": "Идентификатор шаблона уведомления.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор партнера.
       * # Тип: Guid
       */
      "partnerId": {
        "type": "string",
        "text": "Идентификатор партнера.\n# Тип: Guid",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ошибка сохранения.
   * Эти проверки выполняются при работе с базой данных и сторонними сервисами
   */
  "NotificationTemplatePartner.SavingError": {
    "kind": "class",
    "text": "Ошибка сохранения.\nЭти проверки выполняются при работе с базой данных и сторонними сервисами",
    "fields": {
      /**
       * Партнер удален
       */
      "partnerIsDeleted": {
        "type": "NotificationTemplatePartner.SavingError.PartnerIsDeleted",
        "text": "Партнер удален",
      },
      /**
       * Шаблон удален
       */
      "templateIsDeleted": {
        "type": "NotificationTemplatePartner.SavingError.TemplateIsDeleted",
        "text": "Шаблон удален",
      },
    },
  },
  /**
   * Партнер удален
   */
  "NotificationTemplatePartner.SavingError.PartnerIsDeleted": {
    "kind": "class",
    "text": "Партнер удален",
  },
  /**
   * Шаблон удален
   */
  "NotificationTemplatePartner.SavingError.TemplateIsDeleted": {
    "kind": "class",
    "text": "Шаблон удален",
  },
  /**
   * Запрос сохранения приложения
   */
  "PostNotificationTemplateRequest": {
    "kind": "class",
    "text": "Запрос сохранения приложения",
    "fields": {
      /**
       * Приложение
       */
      "data": {
        "type": "NotificationTemplate",
        "text": "Приложение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения шаблона уведомления
   */
  "PostNotificationTemplateResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения шаблона уведомления",
    "fields": {
      /**
       * Шаблон уведомления
       */
      "data": {
        "type": "NotificationTemplate",
        "text": "Шаблон уведомления",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "PostNotificationTemplateResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения шаблона уведомления
   */
  "PostNotificationTemplateResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения шаблона уведомления",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "NotificationTemplate.SavingError",
        "text": "Ошибка сохранения",
      },
      /**
       * Некорректный тип данных для переменной в шаблоне
       */
      "incorrectDataType": {
        "type": "PostNotificationTemplateResponse.Error.IncorrectDataTypeError",
        "text": "Некорректный тип данных для переменной в шаблоне",
      },
      /**
       * Некорректное наименование переменной в шаблоне
       */
      "incorrectVariableNameError": {
        "type": "PostNotificationTemplateResponse.Error.IncorrectVariableNameError",
        "text": "Некорректное наименование переменной в шаблоне",
      },
      /**
       * Некорректный формат Mustache тегов
       */
      "incorrectTagFormatError": {
        "type": "PostNotificationTemplateResponse.Error.IncorrectTagFormatError",
        "text": "Некорректный формат Mustache тегов",
      },
    },
  },
  /**
   * Некорректный тип данных для переменной в шаблоне.
   * Список допустимых типов данных:
   * - Number;
   * - Date;
   * - Phone;
   * - Time
   */
  "PostNotificationTemplateResponse.Error.IncorrectDataTypeError": {
    "kind": "class",
    "text": "Некорректный тип данных для переменной в шаблоне.\nСписок допустимых типов данных:\n- Number;\n- Date;\n- Phone;\n- Time",
  },
  /**
   * Некорректный формат Mustache тегов
   */
  "PostNotificationTemplateResponse.Error.IncorrectTagFormatError": {
    "kind": "class",
    "text": "Некорректный формат Mustache тегов",
  },
  /**
   * Некорректное наименование переменной в шаблоне
   */
  "PostNotificationTemplateResponse.Error.IncorrectVariableNameError": {
    "kind": "class",
    "text": "Некорректное наименование переменной в шаблоне",
  },
  /**
   * Запрос создания связи шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerAttachRequest": {
    "kind": "class",
    "text": "Запрос создания связи шаблона уведомления и партнера",
    "fields": {
      /**
       * Связь шаблона уведомления и партнера
       */
      "notificationTemplatePartner": {
        "type": "NotificationTemplatePartner",
        "text": "Связь шаблона уведомления и партнера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос создания связи шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос создания связи шаблона уведомления и партнера",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutNotificationTemplatePartnerAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на создание шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на создание шаблона уведомления и партнера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "NotificationTemplatePartner.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос удаления связи шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связи шаблона уведомления и партнера",
    "fields": {
      /**
       * Связь шаблона уведомления и партнера
       */
      "notificationTemplatePartner": {
        "type": "NotificationTemplatePartner",
        "text": "Связь шаблона уведомления и партнера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаление связи шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаление связи шаблона уведомления и партнера",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutNotificationTemplatePartnerDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на удаление шаблона уведомления и партнера
   */
  "PutNotificationTemplatePartnerDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на удаление шаблона уведомления и партнера",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "NotificationTemplatePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "NotificationTemplatePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Дата последнего изменения
       */
      "CHANGED_AT": {
        "i": 1,
        "text": "Дата последнего изменения",
      },
      /**
       * Дата создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "Дата создания",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 3,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}